import Box from '@mui/material/Box';
import { FadeInChip } from './FadeInChip';
import { TAGS } from './tags';

type SearchTagsSectionProps = {
  selectedTags: string[];
  handleTagUpdate: (name: string) => void;
};

export const SelectTagsSection = ({
  selectedTags,
  handleTagUpdate,
}: SearchTagsSectionProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        mb: 3,
        gap: 2,
      }}
    >
      {TAGS.map((tag) => {
        return (
          <>
            {selectedTags.includes(tag.name) && tag?.children.length > 0 ? (
              tag.children.map((child) => {
                return (
                  <FadeInChip
                    key={child.name}
                    variant="select"
                    tagName={child.name}
                    handleTagUpdate={handleTagUpdate}
                    selectedTags={selectedTags}
                  />
                );
              })
            ) : (
              <FadeInChip
                key={tag.name}
                variant="select"
                tagName={tag.name}
                handleTagUpdate={handleTagUpdate}
                selectedTags={selectedTags}
              />
            )}
          </>
        );
      })}
    </Box>
  );
};
